import { FiCheckCircle, FiRepeat, FiSend, FiUserPlus } from 'react-icons/fi'
import './HowItWorks.css'
import { useTranslation } from 'react-i18next';
import Cover from '../images/bagCover.png'
const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <FiUserPlus />,
      title: t('howItWorks.steps.createAccount.title'),
      description: t('howItWorks.steps.createAccount.description')
    },
    {
      icon: <FiSend />,
      title: t('howItWorks.steps.sendInvoices.title'),
      description: t('howItWorks.steps.sendInvoices.description')
    },
    {
      icon: <FiCheckCircle />,
      title: t('howItWorks.steps.getPaid.title'),
      description: t('howItWorks.steps.getPaid.description')
    },
    {
      icon: <FiRepeat />,
      title: t('howItWorks.steps.trackAnalyze.title'),
      description: t('howItWorks.steps.trackAnalyze.description')
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <h2 className="section-title">{t('howItWorks.title')}</h2>
        <p className="section-subtitle">{t('howItWorks.subtitle')}</p>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-number">{index + 1}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
          <div className="steps-path"></div>
        </div>

        <div className="demo-container">
          <div className="demo-content">
            <h3>{t('howItWorks.demo.title')}</h3>
            <p>{t('howItWorks.demo.description')}</p>
            <a href="https://youtu.be/4tRHK5d_cf0?si=4IAolXUwPiy90t-L" className="btn btn-accent">{t('howItWorks.demo.cta')}</a>
          </div>
          
          <div className="demo-image">
           
            <img
              src={Cover}
              alt="Invoice software demonstration"
              className="demo-preview"
            />
             
           <div className="play-button">
               <a href='https://youtu.be/4tRHK5d_cf0?si=4IAolXUwPiy90t-L'> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg></a>
            </div>
          
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks